import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { env } from '../../environments/environment';
import { BuyResponseDto, GlitterCartDto, GlitterOfferListDto, GlitterOfferSellDto } from '../api';
import { ExchangeQueryParameters } from '../api/exchange.query';
import { defs } from '../defs';
import { OfferDto } from '../api/offerDto';

@Injectable({
	providedIn: 'root'
})
export class ExchangeService {
	queryParams: BehaviorSubject<any>;
	queryParams$: Observable<any>;

	constructor(private http: HttpClient) {
		this.queryParams = new BehaviorSubject({});
		this.queryParams$ = this.queryParams.asObservable();
	}

	setQueryParams(queryParams) {
		this.queryParams.next(queryParams);
		localStorage.setItem(defs.exchangeFilter, JSON.stringify(queryParams));
	}

	/** Get glitter packages for sale. price in USD */
	public getPackages(queryParams: ExchangeQueryParameters): Observable<GlitterOfferListDto> {
		let params = new HttpParams();

		for (const key in queryParams) {
			if (queryParams.hasOwnProperty(key)) {
				params = params.set(key, queryParams[key]);
			}
		}
		if ('desc' === defs.sortOrders.exchange[queryParams.sortBy]) {
			params = params.set('sortBy', params.get('sortBy') + '-');
		}

		return this.http.get<GlitterOfferListDto>(`${env.beURL}/glitter/list`,
			{	params,	observe: 'body', reportProgress: false});
	}

	public getExchangeCart(): Observable<GlitterCartDto> {
		return this.http.get<GlitterCartDto>(`${env.beURL}/exchange/cart`);
	}

	addToCart(glitterPackageId: string): Observable<any> {
		return this.http.get<any>(env.beURL + '/exchange/cart/add/' + glitterPackageId);
	}

	removeFromCart(glitterPackageId: string): Observable<any> {
		return this.http.delete<any>(env.beURL + '/exchange/cart/remove/' + glitterPackageId);
	}

	buyGlitterPackageCart(currency: string): Promise<BuyResponseDto> {
		return this.http.get<BuyResponseDto>(`${env.beURL}/exchange/cart/buy/${currency}`).toPromise();
	}

	public offerGlitterPackage(offer: GlitterOfferSellDto ): Promise<any> {
		const body = JSON.stringify(offer);
		return this.http.post<any>(`${env.beURL}/glitter/sell`, body).toPromise();
	}

	cancelOffer(id: string) {
		return this.http.delete<any>(`${env.beURL}/glitter/${id}`);
	}

	resellOffer(id: string, sale: OfferDto) {
		const body = JSON.stringify(sale);
		return this.http.post<any>(`${env.beURL}/glitter/resell/${id}`, body);
	}
}